(function () {
  'use strict';

  const VARIANT_ORDER = [
    { id: 'kraeftig', label: 'Kräftige Farben' },
    { id: 'weich', label: 'Weicher Malstil' },
    { id: 'detailreich', label: 'Detailreich' },
  ];
  const MAX_REFINEMENTS = 2;
  const JOB_POLL_INTERVAL_MS = 7_000;
  const JOB_MAX_WAIT_MS = 8 * 60 * 1000;

  function init(options) {
    const $ = (id) => document.getElementById(id);
    const generateBtn = $('pbn-generate-variants-btn');
    const generateWrap = $('pbn-generate-variants-wrap');
    const spinner = $('pbn-preview-spinner');
    const spinnerText = $('pbn-preview-spinner-text');
    const variantReview = $('pbn-variant-review');
    const variantGrid = $('pbn-variant-grid');
    const refinementPanel = $('pbn-refinement-panel');
    const refinementCounter = $('pbn-refinement-counter');
    const refinementChips = $('pbn-refinement-chips');
    const quotaExhausted = $('pbn-quota-exhausted');

    if (!generateBtn || !variantGrid || !refinementChips) return;

    let variants = [];
    let chosenIndex = null;
    let refinementsLeft = MAX_REFINEMENTS;
    let isFinalizing = false;
    let finalizedGenerationId = null;
    let runVersion = 0;

    function showSpinner(text) {
      spinnerText.textContent = text;
      spinner.classList.add('visible');
    }

    function hideSpinner() {
      spinner.classList.remove('visible');
    }

    function invalidateFinal() {
      finalizedGenerationId = null;
      if (typeof options.onInvalidateFinal === 'function') {
        options.onInvalidateFinal();
      }
    }

    async function callApi(url, body) {
      const turnstileToken = await options.getTurnstileToken();
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        referrerPolicy: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ...body, turnstileToken }),
      });
      const result = await response.json().catch(() => ({}));
      if (response.status === 429) return { quotaExhausted: true };
      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Anfrage fehlgeschlagen');
      }
      return result;
    }

    async function submitPreview(extraFields) {
      const context = options.getRequestContext();
      const result = await callApi(options.previewApiUrl, {
        action: 'generate_preview',
        image: context.image,
        colors: context.colors,
        size: context.size,
        style: context.styleId,
        provider: 'fal-seedream-v4',
        clientSessionId: context.clientSessionId,
        ...extraFields,
      });
      return { result, context };
    }

    async function waitForPreview(submitted, isCurrent = () => true) {
      let { result } = submitted;
      const { context } = submitted;
      if (result.quotaExhausted) return result;
      if (result.pending && result.jobId) {
        const deadline = Date.now() + JOB_MAX_WAIT_MS;
        let failedPolls = 0;
        while (result.pending && Date.now() < deadline) {
          if (!isCurrent()) return { cancelled: true };
          await new Promise(resolve => setTimeout(resolve, JOB_POLL_INTERVAL_MS));
          if (!isCurrent()) return { cancelled: true };
          try {
            const response = await fetch(options.previewApiUrl, {
              method: 'POST',
              credentials: 'same-origin',
              cache: 'no-store',
              referrerPolicy: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                action: 'poll_preview',
                jobId: result.jobId,
                clientSessionId: context.clientSessionId,
              }),
            });
            if (response.status === 429) continue;
            const next = await response.json().catch(() => ({}));
            if (!response.ok || !next.success) {
              throw new Error(next.error || 'Der Bildauftrag konnte nicht abgefragt werden.');
            }
            result = next;
            failedPolls = 0;
          } catch (error) {
            failedPolls += 1;
            if (failedPolls >= 4) throw error;
          }
        }
        if (result.pending) {
          throw new Error('Die Bildberechnung dauert ungewöhnlich lange. Bitte versuche es später erneut.');
        }
      }
      if (!result.previewImage || !result.generationId) {
        throw new Error('Die Vorschau enthält keine sichere Kunstwerk-Referenz.');
      }
      return {
        previewImage: result.previewImage,
        generationId: result.generationId,
      };
    }

    async function callPreview(extraFields) {
      return waitForPreview(await submitPreview(extraFields));
    }

    function currentCandidate() {
      return chosenIndex === null ? null : variants[chosenIndex];
    }

    function candidatePayload(candidate) {
      const context = options.getRequestContext();
      return {
        previewImage: candidate.previewImage,
        generationId: candidate.generationId,
        styleId: context.styleId,
        variantId: candidate.id,
        refinementsUsed: MAX_REFINEMENTS - refinementsLeft,
      };
    }

    function notifyCandidate(candidate) {
      invalidateFinal();
      if (typeof options.onCandidateImage === 'function') {
        options.onCandidateImage(candidatePayload(candidate));
      }
    }

    function renderVariantGrid() {
      variantGrid.innerHTML = '';
      variants.forEach((variant, index) => {
        const card = document.createElement(variant.failed ? 'div' : 'button');
        card.className = 'pbn-variant-card' +
          (index === chosenIndex ? ' pbn-active' : '') +
          (variant.failed ? ' pbn-variant-card--failed' : '');

        if (!variant.failed) {
          card.type = 'button';
          card.setAttribute('aria-pressed', index === chosenIndex ? 'true' : 'false');
        }

        if (variant.failed) {
          card.innerHTML = `<span>${variant.label}: fehlgeschlagen</span><button type="button" class="pbn-variant-retry" data-retry-index="${index}">Erneut versuchen</button>`;
        } else if (variant.previewImage) {
          card.innerHTML = `<img src="${variant.previewImage}" alt="${variant.label}"><span>${variant.label}</span>`;
          card.addEventListener('click', () => selectVariant(index));
        } else {
          card.disabled = true;
          card.innerHTML = `<span>${variant.label}: wird erstellt…</span>`;
        }
        variantGrid.appendChild(card);
      });

      variantGrid.querySelectorAll('[data-retry-index]').forEach((button) => {
        button.addEventListener('click', () => retryVariant(parseInt(button.dataset.retryIndex, 10)));
      });
    }

    function selectVariant(index) {
      const candidate = variants[index];
      if (!candidate?.previewImage || !candidate.generationId) return;
      chosenIndex = index;
      updateRefinementCounter();
      renderVariantGrid();
      refinementPanel.style.display = 'block';
      notifyCandidate(candidate);
    }

    function updateRefinementCounter() {
      refinementCounter.textContent = `Noch ${refinementsLeft} Optimierungen übrig`;
      refinementChips.querySelectorAll('.pbn-chip').forEach((chip) => {
        chip.disabled = isFinalizing ||
          (chip.dataset.refinementId !== 'perfect' && refinementsLeft <= 0);
      });
    }

    async function generateVariant(index, expectedRunVersion = runVersion, submitted = null) {
      const variant = VARIANT_ORDER[index];
      try {
        const result = submitted
          ? await waitForPreview(submitted, () => expectedRunVersion === runVersion)
          : await callPreview({ variant: variant.id });
        if (expectedRunVersion !== runVersion) return;
        if (result.quotaExhausted) {
          quotaExhausted.style.display = 'block';
          variants[index] = { ...variant, failed: true };
        } else {
          variants[index] = {
            ...variant,
            previewImage: result.previewImage,
            generationId: result.generationId,
          };
        }
      } catch (error) {
        if (expectedRunVersion !== runVersion) return;
        variants[index] = { ...variant, failed: true };
      }
      renderVariantGrid();
    }

    async function retryVariant(index) {
      variants[index] = { ...VARIANT_ORDER[index] };
      renderVariantGrid();
      await generateVariant(index, runVersion);
      if (variants.every(variant => Boolean(variant.previewImage && variant.generationId)) &&
          typeof options.onGenerationFinished === 'function') {
        options.onGenerationFinished(true);
      }
    }

    async function generateAllVariants() {
      runVersion += 1;
      const expectedRunVersion = runVersion;
      invalidateFinal();
      chosenIndex = null;
      refinementsLeft = MAX_REFINEMENTS;
      refinementPanel.style.display = 'none';
      quotaExhausted.style.display = 'none';
      generateWrap.style.display = 'none';
      showSpinner('Deine Varianten werden erstellt…');
      if (typeof options.onGenerationStarted === 'function') options.onGenerationStarted();
      variants = VARIANT_ORDER.map((variant) => ({ ...variant }));
      variantReview.style.display = 'block';
      renderVariantGrid();

      const pendingVariants = [];
      for (let index = 0; index < VARIANT_ORDER.length; index += 1) {
        const variant = VARIANT_ORDER[index];
        try {
          // One Turnstile widget serves this page, so start each job with its own
          // verified token before creating the next one. Completed jobs can then
          // be polled together and displayed as soon as each result arrives.
          const submitted = await submitPreview({ variant: variant.id });
          if (expectedRunVersion !== runVersion) return;
          pendingVariants.push(generateVariant(index, expectedRunVersion, submitted));
        } catch (error) {
          if (expectedRunVersion !== runVersion) return;
          variants[index] = { ...variant, failed: true };
          renderVariantGrid();
        }
      }

      await Promise.all(pendingVariants);

      if (expectedRunVersion !== runVersion) return;
      hideSpinner();
      if (typeof options.onGenerationFinished === 'function') {
        options.onGenerationFinished(variants.every(variant => Boolean(variant.previewImage && variant.generationId)));
      }
    }

    function reset() {
      runVersion += 1;
      variants = [];
      chosenIndex = null;
      refinementsLeft = MAX_REFINEMENTS;
      isFinalizing = false;
      invalidateFinal();
      variantGrid.innerHTML = '';
      refinementPanel.style.display = 'none';
      variantReview.style.display = 'none';
      quotaExhausted.style.display = 'none';
      generateWrap.style.display = '';
      hideSpinner();
    }

    async function approveCandidate() {
      const candidate = currentCandidate();
      if (!candidate?.generationId || isFinalizing) return;
      if (finalizedGenerationId === candidate.generationId) return;

      isFinalizing = true;
      updateRefinementCounter();
      showSpinner('Dein Kunstwerk wird sicher freigegeben…');

      try {
        const result = await callApi(options.approveApiUrl, {
          action: 'approve_artwork',
          generationId: candidate.generationId,
          clientSessionId: options.getRequestContext().clientSessionId,
        });
        if (result.quotaExhausted) {
          quotaExhausted.style.display = 'block';
          return;
        }
        if (!result.artworkId || !result.checksum) {
          throw new Error('Die Freigabe enthält keine sichere Produktionsreferenz.');
        }

        finalizedGenerationId = candidate.generationId;
        if (typeof options.onFinalArtwork === 'function') {
          options.onFinalArtwork({
            ...candidatePayload(candidate),
            artworkId: result.artworkId,
            checksum: result.checksum,
          });
        }
      } catch (error) {
        alert('Das Kunstwerk konnte nicht freigegeben werden. ' + error.message);
      } finally {
        isFinalizing = false;
        updateRefinementCounter();
        hideSpinner();
      }
    }

    async function applyRefinement(refinementId) {
      const candidate = currentCandidate();
      if (!candidate || isFinalizing) return;

      if (refinementId === 'perfect' || refinementsLeft <= 0) {
        await approveCandidate();
        return;
      }

      showSpinner('Deine Optimierung wird erstellt…');
      try {
        const result = await callPreview({ variant: candidate.id, refinement: refinementId });
        if (result.quotaExhausted) {
          quotaExhausted.style.display = 'block';
          return;
        }

        variants[chosenIndex] = {
          ...candidate,
          previewImage: result.previewImage,
          generationId: result.generationId,
        };
        refinementsLeft -= 1;
        updateRefinementCounter();
        renderVariantGrid();
        notifyCandidate(variants[chosenIndex]);

        if (refinementsLeft === 0) {
          hideSpinner();
          await approveCandidate();
          return;
        }
      } catch (error) {
        alert('Die Optimierung konnte nicht erstellt werden. ' + error.message);
      } finally {
        hideSpinner();
      }
    }

    generateBtn.addEventListener('click', generateAllVariants);
    refinementChips.querySelectorAll('.pbn-chip').forEach((chip) => {
      chip.addEventListener('click', () => applyRefinement(chip.dataset.refinementId));
    });

    return { reset };
  }

  window.PictumiraAiFlow = { init };
})();
